var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { defaultIconProps } from '../icon';
export var IconTick = function (props) { return (_jsx("span", __assign({ className: "icon icon__tick" }, { children: _jsx("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M11.3982 5.20599C11.7084 4.90497 12.2017 4.90486 12.5121 5.20574L12.7586 5.44473C13.0828 5.75896 13.0829 6.27901 12.7588 6.59336L7.39758 11.794C7.08745 12.0949 6.59447 12.0951 6.28406 11.7946L3.24171 8.84869C2.91717 8.53444 2.91702 8.01397 3.24139 7.69954L3.48811 7.46038C3.79821 7.15979 4.29092 7.15958 4.60127 7.45992L6.84107 9.62748L11.3982 5.20599Z", fill: props.fill || defaultIconProps.fill }) })) }))); };
